import { processLoginData } from 'src/utils/serialization';
import { fetchJson } from 'src/utils/fetch';
import cookies from 'src/utils/cookie';

export const unionPayProcess = (pathname: string, search: string, onSuccess?: Function) => {
  window.upsdk.pluginReady(function () {
    window.upsdk.appletAuth({
      success: function (data) {
        const { code = '' } = data;
        fetchJson({
          url: '/api/api/v1/patient/user/getThirdOpenId',
          type: 'POST',
          isloading: false,
          data: {
            channelSource: cookies.get('channelSource') || '',
            channelResourceCode: cookies.get('channelResourceCode') || '' ,
            code
          },
          success: (res) => {
            const { code = '0', result: { openId = '', token = '', backendToken = '' } = {} } = res;
            cookies.set('union_openId', openId);
            if (code === '0') {
              fetchJson({
                url: '/api/api/v1/patient/user/bindThirdUser',
                type: 'POST',
                isloading: false,
                needLogin: false,
                data: {
                  channelSource: cookies.get('channelSource') || '',
                  channelResourceCode: cookies.get('channelResourceCode') || '',
                  accessToken: token,
                  backendToken: backendToken,
                  openId: openId,
                  registerFlag: false,
                },
                success: (res) => {
                  console.log(pathname, search);
                  console.log(JSON.stringify(res));
                  const { code = '0', result } = res;
                  if (code === '0') {
                    processLoginData(result);
                    typeof onSuccess === 'function' && onSuccess();
                  } else if (code === '-99') {
                    window.reactHistory.replace({
                      pathname: '/hospital/unionauth',
                      search: `pathname=${encodeURIComponent(pathname)}&jumpSearch=${encodeURIComponent(search)}`
                    });
                  }
                }
              });
            }
          },
        })
      }
    });
  });
}